import { routes as gamesRoutes } from "apps/Game/constants";
import { routes as memberRoutes } from "apps/Member/constants";
import { routes as profileRoutes } from "apps/Profile/constants";
import { routes as providersRoutes } from "apps/Providers/constants";

export const getPaths = () => ({
	member: memberRoutes,
	games: gamesRoutes.games,
	providers: providersRoutes.providers,
	profile: profileRoutes.profile
});
